import React, {useEffect, useRef, useState} from "react";
import { Toast } from "primereact/toast";
import GeneralVehicleForm from "./Components/GeneralVehicleForm";
import './UnitsCatalog.scss'
import { useParams } from "react-router-dom";
import {
    addUnitCatalog,
    getDashboardData,
    getOptionsParallel,
    getUnitFile,
    INITIAL_VEHICLES,
    updateUnitCatalog,
    uploadImage
} from "../Integration";
import DocumentsDashboard from "./Components/DocumentsDashboard";
import CreditAndPolicyForm from "./Components/CreditAndPolicyForm";
import { Button } from "primereact/button";
import EquipmentForm from "./Components/EquipmentForm";
import Maintenance from "./Components/Maintenance";
import Swal from "sweetalert2";
import {modalLoading} from "../../../../components/atoms/ModalLoading/loadingModal";
import {desEncriptar} from "../../../../utilidades/encriptacion";


const obtenerUsuarioId = () => {
    try {
        return JSON.parse(
            desEncriptar(
                sessionStorage.getItem('dataClient'),
                process.env.REACT_APP_CLAVE_INCRIPTACION
            )
        )
    } catch {
        return null;
    }
};

const UnitsCatalog = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(null);
    const [formData, setFormData] = useState(INITIAL_VEHICLES);
    const [location, setLocation] = useState(null);
    const [options, setOptions] = useState({});
    const [files, setFiles] = useState([]);
    const fileUploadRef = useRef(null);

    const userData = obtenerUsuarioId();
    const permisos = userData?.permissions ?? [];

    const getPermisosModulo = (permisos, padre, modulo) => {
        const grupo = permisos.find(g => g.padre === padre);
        if (!grupo) return [];
        const mod = grupo.modulos.find(m => m.nombre === modulo);
        return mod?.permisos ?? [];
    };

    const permisosModulo = getPermisosModulo(permisos, 'Mantenimiento', 'Catálogo de unidades');
    const puedeCambiarEstatus = permisosModulo.includes('CAMBIAR ESTATUS');
    const puedeEditar = permisosModulo.includes('ACTUALIZAR DATOS');


    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const parseDate = (dateString) => {
        if (!dateString) return null;

        try {
            const parsedDate = new Date(dateString);

            return new Date(
                parsedDate.getUTCFullYear(),
                parsedDate.getUTCMonth(),
                parsedDate.getUTCDate()
            );
        } catch (error) {
            console.error('Error parsing date:', error);
            return null;
        }
    };

    const handleDateChange = (fieldName) => (e) => {
        setFormData(prevService => ({
            ...prevService,
            [fieldName]: e.value ? e.value.toISOString().split('T')[0] : null
        }));
    };


    useEffect(() => {
        if (id) {
            setLoading(true);
            modalLoading('Cargando datos de la unidad')
            getDashboardData(id)
                .then((data) => {
                    setFormData(data.unitData);
                    setLocation(data.location);
                    setLoading(false);
                    Swal.close();
                })
                .catch((error) => {
                    console.error(error);
                    toastRef.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No se pudo cargar el servicio',
                        life: 3000
                    });
                    setLoading(false);
                    Swal.close();
                })
        } else {
            setFormData(INITIAL_VEHICLES);
        }
    }, [id]);

    useEffect(() => {
        getOptionsParallel()
            .then((data) => setOptions(data))
            .catch((error) => console.error(error));
        getUnitFile(id)
            .then((data) => setFiles(data))
            .catch((error) => console.error(error));
    }, []);

    const uploadHandler = async ({ files }) => {
        const formData = new FormData();
        formData.append("file", files[0]);
        const image = await uploadImage(formData);
        handleInputChange('FOTO', `https://servicios.sumaenlinea.mx/Imagenes/${image.fileName}`);
        handleInputChange('FOTOGRAFIA', image.fileName);
        fileUploadRef.current.clear();
    };

    const addUnit = async () => {
        try {
            if (id) {
                await updateUnitCatalog(formData);
                await Swal.fire('Registro actualizado', '', 'success');
            } else {
                await addUnitCatalog(formData);
                await Swal.fire('Registro guardado', '', 'success');
            }
        } catch (e) {
            await Swal.fire('Error', 'No se pudo guardar el registro', 'error');
        }
    }

    const toastRef = useRef(null);
    return (

        <div className="containerC">
            <Toast ref={toastRef}/>
            <div className="sticky top-0 z-5 pb-4 px-4"
                 style={{
                     backgroundColor: 'rgba(255, 255, 255, 0.95)',
                     backdropFilter: 'blur(5px)'
                 }}>
                <div className="actionButtons">
                    <Button
                        label="Guardar"
                        icon="pi pi-check"
                        onClick={addUnit}
                        disabled={!puedeEditar && !puedeCambiarEstatus}
                    />
                </div>
            </div>
            <GeneralVehicleForm formData={formData} location={location} handleInputChange={handleInputChange}
                                parseDate={parseDate} handleDateChange={handleDateChange} options={options}
                                uploadHandler={uploadHandler} fileUploadRef={fileUploadRef}
                                tienePermiso={puedeEditar}
                                puedeCambiarEstatus={puedeCambiarEstatus}/>
            <CreditAndPolicyForm formData={formData} handleInputChange={handleInputChange} parseDate={parseDate}
                                 handleDateChange={handleDateChange} tienePermiso={puedeEditar}/>
            <DocumentsDashboard formData={formData} handleInputChange={handleInputChange} parseDate={parseDate}
                                handleDateChange={handleDateChange} files={files} unit={id}
                                tienePermiso={puedeEditar}/>
            <EquipmentForm formData={formData} handleInputChange={handleInputChange} parseDate={parseDate}
                           handleDateChange={handleDateChange} options={options} tienePermiso={puedeEditar}/>
            <Maintenance formData={formData} handleInputChange={handleInputChange} id={id} tienePermiso={puedeEditar}/>

        </div>
    )
}

export default UnitsCatalog
